import { useEffect, useState } from "react";

interface TocItem {
  id: string;
  heading: string;
}

interface ArticleTocProps {
  items: TocItem[];
}

export default function ArticleToc({ items }: ArticleTocProps) {
  const [activeId, setActiveId] = useState(items[0]?.id ?? "");

  useEffect(() => {
    const onScroll = () => {
      let current = items[0]?.id ?? "";
      items.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 160) {
          current = item.id;
        }
      });
      setActiveId(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [items]);

  return (
    <nav
      aria-label="文章目录"
      className="rounded-card border border-background-200/80 bg-background-50 p-5"
    >
      <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-list-check-2 text-primary-500"></i>
        </span>
        本页目录
      </h2>
      <ol className="mt-4 flex flex-col gap-1 border-l border-background-200 pl-4">
        {items.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              onClick={() => {
                const el = document.getElementById(item.id);
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              className={`block w-full text-left text-sm leading-relaxed transition-colors duration-200 ${
                activeId === item.id
                  ? "font-medium text-primary-700"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              {item.heading}
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
}